import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
  Fade,
} from "@material-ui/core";

import { Button } from "../Wrappers";
import { useGroupDispatch, leaveGroup } from "../../context/GroupContext";
import { useTranslation } from "../../localization";

// Confirmation dialog for leaving (removing oneself from) the given group. Used
// from the group selector in the header and sidebar. On success it reloads the
// user's groups (switching to a remaining group, or the no-groups screen when
// none are left) and calls `onLeft`.
export default function LeaveGroupDialog({ open, group, onClose, onLeft }) {
  var groupDispatch = useGroupDispatch();
  var t = useTranslation();

  var [error, setError] = useState(null);
  var [loading, setLoading] = useState(false);

  function handleClose() {
    if (loading) {
      return;
    }
    setError(null);
    onClose();
  }

  async function handleConfirm() {
    if (loading) {
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await leaveGroup(groupDispatch, group);
      setLoading(false);
      onClose();
      if (onLeft) {
        onLeft(group);
      }
    } catch (err) {
      setError(err.message || t.layout.couldNotLeaveGroup);
      setLoading(false);
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>{t.layout.leaveGroupTitle}</DialogTitle>
      <DialogContent>
        <Fade in={Boolean(error)}>
          <Typography color="secondary" style={{ marginBottom: 8 }}>
            {error}
          </Typography>
        </Fade>
        <Typography>{t.layout.leaveGroupConfirm(group)}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" disabled={loading}>
          {t.common.cancel}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="secondary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : t.header.leaveGroup}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
